<template>
	<div
		class="plug-in-unit"
    :style="{
      'animation: firstHeightAnimation 0.3s forwards;':menuTitle.length % 3 === 0,
      'animation: secondHeightAnimation 0.3s forwards;':menuTitle.length % 4 === 0
    }"
		v-if="showBar"
	>
		<div
			class="plug-content"
			ref="plug"
		>
			<header class="menu-title" :style="menuTitle[0].title === '飞椽零代码开发平台'?'justify-content: flex-start;gap: 32%;padding: 33px 28.8% 20px 2px;':''">
				<div
					class="name"
					v-for="item in menuTitle"
					:key="item.id"
          :style="{
          'marginLeft':item.title === '飞椽能力家族'?'34px':'',
          'marginRight':item.title === '飞椽开发平台'?'':'',
          }"
				>
					<div
            v-if="item.title !== ''"
						class="line"
            :style="lineStyle(item.title)"
						:class="[item.title === '平台解决方案' ? 'platform' : 'scene']"
					></div>
					<span class="title">{{ item.title }}</span>
				</div>
			</header>
			<body class="plug-grid" :style="{
        'animation: firstHeightAnimation 0.3s forwards;':menuTitle.length % 3 === 0,
        'animation: secondHeightAnimation 0.3s forwards;':menuTitle.length % 4 === 0,
      }"
      :class="{ 'custom-style': menuTitle[0].title === '飞椽零代码开发平台' }"
    >
        <section class="card-group" v-if="cardsList.length">
          <div class="card-item" v-for="(item, index) in cardsList" @click="onJumpClick(item)" :key="index" :style="{backgroundImage: 'url('+item.backgroundImage+')'}">
            <div class="title">
              {{ item.title }}
              <span v-if="item.title === '专业版'" class="new-sign">New</span>
            </div>
            <div class="text">{{ item.text }}</div>
          </div>
        </section>
				<div class="menu-list-group" :style="menuTitle[0].title === '飞椽零代码开发平台'?'grid-template: repeat(3, 1fr) / repeat(3, 1fr);margin-left: 56px;':''">
          <div
            v-for="item in menuList"
            :key="item.id"
            :class="[item.hover, 'plug-grid-item']"
            @click="onJumpClick(item)"
            @mouseover="changeIndex(item.id, menuList)"
            @mouseout="changeIndexBack(item.id, menuList)"
          >
            <!-- 图标 -->
            <div class="logo-box">
              <svg
                aria-hidden="true"
                class="logo-box"
              >
                <use :xlink:href="item.show ? '#' + item.hoverIcon : '#' + item.icon" />
              </svg>
            </div>
            <!-- 标题 简介 -->
            <div class="text-box">
              <h6 class="title">
                {{ item.title }}
                <span v-if="[11, 12, 13].includes(item.id)" class="new-sign">New</span>
              </h6>
              <span class="text">{{ item.text }}</span>
            </div>
          </div>
        </div>
			</body>
		</div>
	</div>
</template>

<script>
export default {
	name: 'MenuSelectItem',
	components: {},
	props: {
		// 菜单选择展示隐藏
		showBar: {
			type: Boolean,
			required: false,
			default: false
		},
		// 菜单数据
		menuList: {
			type: Array,
			required: false,
			default: () => {
				return [];
			}
		},
    // 卡片数据(卡片)
    cardsList: {
			type: Array,
			required: false,
			default: () => {
				return [];
			}
		},
		// 菜单标题
		menuTitle: {
			type: Array,
			required: false,
			default: () => {
				return [];
			}
		}
	},
	data() {
		return {
      index: 0
    };
	},
	methods: {
		/**
		 * @desc: 图标hover效果
		 */
		changeIndex(e, val) {
			val[e].show = true;
		},
		changeIndexBack(e, val) {
			val[e].show = false;
		},
		/**
		 * @desc: 点击功能跳转页面
		 */
		onJumpClick(item) {
			if (item.id === 11) {
				window.open('https://gantt.bimcc.net/docs/index.html')
				return
			}
			if (item.path === '/web-page/templates') {
				this.$emit('cancel', '');
				this.$router.push({ name: 'Template', query: { id: '5' } });
			} else {
				this.$emit('cancel', '');
				this.$router.push({ path: item.path });
			}
		},
    lineStyle(title) {
      if (title === '飞椽能力家族') {
        return 'width: 102px;'
      }
      if (title === '飞椽零代码开发平台') {
        return 'width: 148px;'
      }
    }
	}
};
</script>

<style lang="less" scoped>
.scene {
	width: 70px;
	background: #ffec9e;
}
.platform {
	width: 100px;
	background: #ffec9e;
}
.pink:hover {
	background-color: #fff5f7;
}
.yellow:hover {
	background-color: #fff7f0;
}
.green:hover {
	background-color: #edf7f4;
}
.blue:hover {
	background-color: #edf5fc;
}
.purple:hover {
	background-color: #f3f0fc;
}
@keyframes firstHeightAnimation {
	0% {
		height: 0;
		opacity: 0;
	}
	100% {
		height: 315px;
		opacity: 1;
	}
}
@keyframes secondHeightAnimation {
	0% {
		height: 0;
		opacity: 0;
	}
	100% {
		height: 387px;
		opacity: 1;
	}
}
.plug-in-unit {
	display: flex;
	justify-content: center;
	position: fixed;
	left: 0;
	right: 0;
	top: 64px;
	overflow: hidden;
	width: 100%;
	padding-right: 30px;
	box-sizing: border-box;
	border-top: 0.1px solid #e6e9f0;
	background-color: #fff;
	box-shadow: 0px 4px 24px 0px rgba(169, 173, 184, 0.12);
	.plug-content {
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 1200px;
    min-width: 1236px;
		padding: 0px 0 22px 0;
		box-sizing: border-box;
		.menu-title {
			display: flex;
			justify-content: space-between;
			width: 100%;
			padding: 32px 22.3% 20px 20px;
			box-sizing: border-box;
			.name {
				position: relative;
				height: 24px;
				.line {
					position: absolute;
					left: 0;
					right: 0;
					bottom: 0;
					height: 8px;
					border-radius: 3px;
					opacity: 0.6;
				}
				.title {
					position: absolute;
					left: 0;
					right: 0;
					top: 0;
					color: #2a2f3d;
					line-height: 24px;
					font-family: PingFangSC-Medium, PingFang SC;
					font-weight: 500;
					font-size: 16px;
					letter-spacing: 1px;
					white-space: nowrap;
				}
			}
		}
    .custom-style {
      display: flex;
    }
		.plug-grid {
			flex: 1;
			width: 100%;
			height: 100%;
      .card-group {
        display: flex;
        flex-direction: column;
        gap: 16px;
        .card-item {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
          gap: 4px;
          flex-shrink: 0;
          width: 240px;
          height: 96px;
          padding: 0px 24px;
          box-sizing: border-box;
          border-radius: 12px;
          background-position: 100% 100%;
          background-size: 100% 100%;
          cursor: pointer;
          &:hover {
            box-shadow: 0px 4px 0px 0px #E0E2FF;
          }
          .title {
            display: flex;
            align-items: center;
            color: #181B22;
            font-family: "PingFang SC";
            font-size: 16px;
            font-style: normal;
            font-weight: 500;
            line-height: 24px;
            letter-spacing: 0.5px;
            .new-sign {
              display: inline-flex;
              height: 14px;
              margin-left: 6px;
              padding: 0px 4px;
              justify-content: center;
              align-items: flex-start;
              flex-shrink: 0;
              border-radius: 4px;
              background: linear-gradient(180deg, rgba(255, 255, 255, 0.20) 0%, rgba(255, 255, 255, 0.00) 100%), var(--semantic-error-background-variant, #FC5558);
              box-shadow: 0px 0.5px 1px 0px rgba(252, 85, 88, 0.24), 0px 1px 2px 0px rgba(252, 85, 88, 0.12), 0px 0.5px 3px 0px rgba(252, 85, 88, 0.12);
              color: #FFF4F4;
              font-family: "Helvetica Neue";
              font-size: 10px;
              font-style: italic;
              font-weight: 500;
              line-height: 14px;
              letter-spacing: 0.5px;
            }
          }
          .text {
            color: #434F70;
            font-family: "PingFang SC";
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 150%;
            letter-spacing: 0.4px;
          }
        }
      }
      .menu-list-group {
        display: grid;
        grid-template: repeat(3, 1fr) / repeat(4, 1fr);
        grid-gap: 0px 16px; // 行列间距都为10 
        width: 100%;
        height: 100%;
        .plug-grid-item {
          cursor: pointer;
          display: flex;
          width: 100%;
          height: 72px;
          padding: 16px 0 16px 20px;
          box-sizing: border-box;
          animation-fill-mode: forwards;
          animation: showMenuList 0.5s 1;
          @keyframes showMenuList {
            /*设置内容由显示变为隐藏*/
            0% {
              opacity: 0;
              transform: translateY(-100%);
            }
            100% {
              opacity: 1;
              transform: translateY(0);
            }
          }
          .logo-box {
            width: 40px;
            height: 40px;
            .logo {
              width: 40px;
              height: 40px;
            }
          }
          .text-box {
            flex: 1;
            padding-left: 16px;
            box-sizing: border-box;
            text-align: left;
            .title {
              display: flex;
              align-items: center;
              height: 22px;
              color: #2a2f3d;
              line-height: 22px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              font-size: 14px;
              white-space: nowrap;
              .new-sign {
                display: inline-flex;
                height: 14px;
                margin-left: 6px;
                padding: 0px 4px;
                justify-content: center;
                align-items: flex-start;
                flex-shrink: 0;
                border-radius: 4px;
                background: linear-gradient(180deg, rgba(255, 255, 255, 0.20) 0%, rgba(255, 255, 255, 0.00) 100%), var(--semantic-error-background-variant, #FC5558);
                box-shadow: 0px 0.5px 1px 0px rgba(252, 85, 88, 0.24), 0px 1px 2px 0px rgba(252, 85, 88, 0.12), 0px 0.5px 3px 0px rgba(252, 85, 88, 0.12);
                color: #FFF4F4;
                font-family: "Helvetica Neue";
                font-size: 10px;
                font-style: italic;
                font-weight: 500;
                line-height: 14px;
                letter-spacing: 0.5px;
              }
            }
            .text {
              height: 18px;
              color: #616e8f;
              line-height: 18px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              font-size: 12px;
              white-space: nowrap;
            }
          }
        }
        .plug-grid-item:hover {
          border-radius: 8px;
        }
      }
		}
	}
}
</style>
